"use strict";

const FacilityInspectionOpenFindings = function () {
  const stringKey = "open-findings";
  const tabHeader = "Open Findings";

  var loadListeners = function (data) {};

  var unloadListeners = function () {};

  var getProps = function (data) {
    return {};
  };

  var getStringKey = function () {
    return stringKey;
  };

  var getTabHeader = function () {
    return tabHeader;
  };

  return {
    loadListeners,
    unloadListeners,
    getStringKey,
    getTabHeader,
    getProps,
  };
};

module.exports = FacilityInspectionOpenFindings();
